import React, { Fragment } from "react";
import GenericApp from "../GenericApp";
import UserResourceAppForm from "./UserResourceAppForm";
import { useDispatch, useSelector } from "react-redux";
import GenericAppUtils from "../GenericApp/GenericAppUtils";
import { useHistory } from "react-router-dom";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";
import { useIntl } from "react-intl";
import AttachFileIcon from "@material-ui/icons/Attachment";
import { USER_RESOURCE_DESTROY, USER_RESOURCE_STORE, USER_RESOURCE_UPDATE } from "../../../redux/action-types/UserResourceActionTypes";
import FileUploaderActions from "../../../redux/sagas/actions/FileUploaderActions";

export const USER_RESOURCE_FRONTEND_INDEX_URL = '/apps/user';
export const USER_RESOURCE_PAGINATE_URL = '/UserResource/Paginate';
const NAME = 'user-resource-app';
const TITLE = 'User';
const SUBTITLE = 'App';
const ICON = <AttachFileIcon />;

function TenantApp(props) {

  const dispatch = useDispatch();
  const hist = useHistory();
  let { page, pageLimit } = useSelector(({ genericAppReducer }) => genericAppReducer);
  const intl = useIntl();

  const handleIndex = () => {
    hist.push(USER_RESOURCE_FRONTEND_INDEX_URL);
  }

  const handleDestroy = (values) => {
    dispatch({type: USER_RESOURCE_DESTROY, payload: values});
  };

  const handleSubmit = (values, formik) => {
    const type = values.id ?  USER_RESOURCE_UPDATE : USER_RESOURCE_STORE;
    dispatch({type: type, payload: values});
  };

  const AppSettings = {
    name: `${NAME}-app`,
    title: <IntlMessages id={TITLE} />,
    subTitle: SUBTITLE,
    searchTitle: intl.formatMessage({ id: 'Search...' }),
    notFoundTitle: <IntlMessages id={'No records found'} />,
    isCreate: true,
    isRead: true,
    isUpdate: true,
    isDelete: true,
    urls: {
      indexFrontend: USER_RESOURCE_FRONTEND_INDEX_URL
    },
    createButton: {
      title: <IntlMessages id={'Create New'} />,
      icon: null
    },
    headers: [
      <IntlMessages id={'Name'} />,
      <IntlMessages id={'Id'} />,
      <IntlMessages id={'Oauth Id'} />,
      <IntlMessages id={'Email'} />,
      <IntlMessages id={'Cellphone'} />,
    ],
    menuList: [
      {
        title: "Menu",
        items: [
          { id: 1, name: <IntlMessages id={TITLE} />, slug: `${NAME}-all`, icon: ICON, onClick: handleIndex }
        ]
      }
    ],
    recordMenuList: [
      {
        title: "Record Menu",
        items: [
          // { id: 1, name: "Users", slug: "users", icon: <GroupIcon />, onClick: (e) => console.log(e) }
        ]
      }
    ],
    dispatchActions: {
      paginate: GenericAppUtils.GetPaginateFunc(USER_RESOURCE_PAGINATE_URL),
    },
    events: {
      onRenderTitle: (item) => (item.firstName),
      onRenderSubTitle: (item) => (item.userName),
      onRenderAvatar: (item) => (FileUploaderActions.getDownloadImageUrl(item.profilePictureUrl, false)),
      onRenderExtraCells: (item) => ([item.id,item.oauthProviderId, item.email, item.cellphone]),
      onEditClick : (item) => console.log(item),
      onShowClick : (item) => console.log(item),
      onDeleteClick : handleDestroy,
      onDeleteMultiple : (items) => console.log(items),
      onCreateClick : (e) => console.log(e),
      onStarClick: null, //(item, status) => console.log(item, status),
      onSearchChange: null,//(s) => console.log(s),
      onSearchEnterKeyDown: null, //if this property is null, it will call the default search endpoint
    }
  };

  return (
    <Fragment>
      <GenericApp appSettings={AppSettings} form={<UserResourceAppForm onSubmit={handleSubmit}/>} isUseDialog={false} />
    </Fragment>
  );

}

export default TenantApp;
